import { useEffect, useState } from "react";
import { Play, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export const RecordingPlayer = ({ id }) => {
  const { t } = useLang();
  const [url, setUrl] = useState("");
  const [state, setState] = useState("idle");

  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  const load = async () => {
    setState("loading");
    try {
      const res = await api.get(`/recordings/${id}/audio`, { responseType: "blob" });
      setUrl(URL.createObjectURL(res.data));
      setState("ready");
    } catch {
      setState("error");
    }
  };

  if (url) return <audio src={url} controls autoPlay className="w-full max-w-xs h-9" data-testid={`recording-audio-${id}`} />;
  return (
    <button type="button" onClick={load} disabled={state === "loading"} data-testid={`recording-play-${id}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold rounded-full bg-[#1C1917] text-[#FAF7F2] px-3 py-1.5 hover:bg-[#3B2F25] transition-colors disabled:opacity-60">
      {state === "loading" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Play className="w-3.5 h-3.5" />}
      {state === "loading" ? t.rec.loading : state === "error" ? t.reader.ttsError : t.rec.play}
    </button>
  );
};
